/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyJobProfile } from '../models/SurveyJobProfile';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyJobProfileService {

    /**
     * Get Survey Job Profile List
     * @returns any Success
     * @throws ApiError
     */
    public static listProfiles({
        purchased,
        surveyVendorId,
        surveyJobProfileId,
        nextSurveyJobProfileId,
        plan,
        exclude,
        mapped,
        hasRollups,
    }: {
        purchased?: 'true' | 'false',
        surveyVendorId?: string,
        surveyJobProfileId?: string,
        nextSurveyJobProfileId?: string,
        plan?: Array<number>,
        exclude?: Array<string>,
        mapped?: string,
        hasRollups?: boolean,
    }): CancelablePromise<{
        rows: Array<SurveyJobProfile>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/jobprofile',
            query: {
                'purchased': purchased,
                'surveyVendorId': surveyVendorId,
                'surveyJobProfileId': surveyJobProfileId,
                'nextSurveyJobProfileId': nextSurveyJobProfileId,
                'plan': plan,
                'exclude': exclude,
                'mapped': mapped,
                'hasRollups': hasRollups,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
